import { regex } from './common'
const alphanumeric =/[a-zA-Z0-9,. ]/

export default value => {
  return regex(value, alphanumeric)
}
